import { Dispatch, SetStateAction, useState } from 'react';

export function useSynchronizedState<T>(
  propValue: T,
): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(propValue);
  const [prevPropValue, setPrevPropValue] = useState<T>(propValue);

  // If the prop changed since the last render, update state immediately
  // https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes seems to validate this pattern as well
  if (propValue !== prevPropValue) {
    setPrevPropValue(propValue);
    setState(propValue);
  }

  return [state, setState];
}
